<script>
import dateTool from '@/tools/date';
// import SignedEvent from '@/classes/events/SignedEvent';
import proofEventMixin from '@/components/views/3-collect/_shared/proof-event-mixin'

export default {
    name: 'TestCW',
    components: {},
    mixins: [proofEventMixin],
    props: ['todo', 'test1', 'testcode', 'holder1'],
    computed: {
        fullname() {
            return this.holder1.firstName + ' ' + this.holder1.lastName;
        },
        test() {
            return this.signedEvent.event.test;
        },
        monthName() {
            return dateTool.dateToString(this.holder1.birthDate, 'MMMM');
        },
        holderBirthDate() {
            return dateTool.dateToString(this.holder1.birthDate.split('-'), 'dd-MMMM-yyyy');
        },
        title() {
            return this.$t('components.NegativeTest.resultNegative') + ' ' + this.test1.co // + ' (' + this.location + ')';
        }
    },
    methods: {
        openInfo() {
            const manufacturer = this.test1.testdevicemanufacturer;
            const testname = this.test1.nm;
            const dataForV3 = {
                name: this.fullname,
                birthDateString: this.holder1.birthDate, // dateTool.dateToString(this.holder1.birthDate.split('-'), 'dd-MMMM-yyyy'),
                testType: this.test1.testtype,
                testName: testname,
                testLocation: this.test1.is,
                sampleDate: dateTool.dateToString(this.test1.sc.split('T')[0].split('-'), 'dd-MMMM-yyyy'),
                manufacturer: manufacturer,
                identificationCode: this.test1.ci,
                country: this.test1.countryfullname
            }

            this.$store.commit('modal/set', {
                messageHead: this.$t('message.info.testResultAbout.head'),
                messageBody: this.$t('message.info.testResultAbout.bodyV3', dataForV3),
                closeButton: true
            })
        }
    }
}
</script>

<template>
    <div class="proof-event">
       <div class="proof-event__status proof-event__line">
            {{ title }}
        </div>
         <div class="proof-event__line">
             {{$t('components.vaccination.name')}}: {{ fullname }}
        </div>
        <div class="proof-event__line">
            {{$t('components.vaccination.dateOfBirth')}}: {{ this.holder1.birthDate }}
        </div>

        <button
            @click="openInfo()"
            type="button"
            class="info-button">
            <img src="assets/img/icons/info.svg" alt=""/>
        </button>
    </div>
</template>

<style lang="scss"></style>
